import { Essential } from '@/components/shared/parts/essential';
import { Recreation } from '@/types';
import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { RecreationFormValues } from './recreationNewForm';

export const RecreationAdditionalFacilityFeeForm: React.FC<{
  mode: 'new' | 'edit';
  recreation?: Recreation;
  register?: UseFormRegister<RecreationFormValues>;
}> = ({ mode, recreation, register }) => {
  return (
    <>
      <div className='d-flex mt-4'>
        <h5 className='text-black font-weight-bold'>追加施設費</h5>
        <Essential />
      </div>
      <p className='small my-0'>
        オンライン開催のみ。１回のレクで新たに施設が追加される
      </p>
      {mode === 'new' && register && (
        <input
          type='text'
          className='p-2 w-100 rounded border border-secondary'
          placeholder='追加施設費を入力'
          {...register('additionalFacilityFee', {
            required: true,
          })}
        />
      )}
      {mode === 'edit' && recreation && (
        <input
          type='text'
          className='readonly p-2 w-100 rounded border border-secondary'
          value={recreation.additionalFacilityFee - 1000}
          readOnly
        />
      )}
      <p className='small my-0'>基本は追加施設1施設あたり1,000円です。</p>
    </>
  );
};
